import React from "react";
import "./section1.css";
import '../../CategoryItems/ImgComponent/style/ImgComp.css'
import AllItem from "../../newArrival/AllItem";
import productData from '../../../json/product.json'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Autoplay, Pagination } from 'swiper/modules'
import line1 from '../../../assets/icons/line1.avif'


const Sec1Main = () => {

  const data = productData?.newPrd


  return (

    <div className="m-2   main">
      <div className=" text-center text-xl uppercase font-mono  mb-10 relative sec1-heading">
        <h1 className="sec1-heading">You might also like</h1>
        <div className='flex justify-center line'>
          <img src={line1} alt="" height={50} width={300} style={{ objectFit: 'cover', }} className='line' />
        </div>
      </div>
      <div className=" gap-8 justify-center mx-8 ">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          autoplay={{
            delay: 1500,
            disableOnInteraction: false,
          }}
          breakpoints={{

            405: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            500: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            650: {
              slidesPerView: 2,
              spaceBetween: 20,
            },
            710: {
              slidesPerView: 3,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 3,
              spaceBetween: 10,
            },
            951: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1290: {
              slidesPerView: 4,
              spaceBetween: 10,
            },
            1390: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1490: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1790: {
              slidesPerView: 5,
              spaceBetween: 10,
            },
            1920: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
            3000: {
              slidesPerView: 6,
              spaceBetween: 10,
            },
          }}
          modules={[Pagination,Autoplay ]}
          className='mySwiper'
        >
          {data?.slice(0, 15)?.map((x, i) => {
            return (
              <SwiperSlide key={i}>
                <div>
                  <AllItem
                  key={x?.id}
                    item={x}
                    prdimg={x.prdimg}
                    prdname={x.prdname}
                    prdprice={x.prdprice}
                  />
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div >
  );
};

export default Sec1Main;
